import { NavLink } from "react-router-dom";
import css from "./style.module.css";
const AdminMain = () => {
  return (
    <main className={css.root}>
      <div className="container">
        <div className={css["main-content"]}>
          <div className={css.title}>
            <h1>Сервис по заявкам на ремонт ПК.</h1>
            <h2>
              <u>Для администраторов</u>
            </h2>
            <h3>
              Просмотрите наличие новых заявок и решите их. Затем измените
              статус выполненных заявок
            </h3>
          </div>
          <div className={css.buttons}>
            <button className={css.btn}>
              <NavLink to="/manage-requests">Управление заявками</NavLink>
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AdminMain;
